// src/config.ts

type Config = {
    API_URL: string;
};

// CRA also uses NODE_ENV=production for a staging build. Honor an explicit full API base URL
// (including /api) at build time in every mode; an unset override keeps the production default.
const config: Config = {
    API_URL: process.env.REACT_APP_API_URL || 'https://api.goly-esa.sk/api',
};

export default config;
